import React, { useState, useMemo, useEffect } from "react";
import { Tabs } from "antd";
import Layout from "../../components/Layout/Layout";
import { useNavigate, useParams } from "react-router-dom";
import TrainingPlanManager from "./Components/TrainingPlanManager/TrainingPlanManager";
import BudgetOverview from "./Components/BudgetOverview/BudgetOverview";
import TrainingRequestValidation from "./Components/TrainingRequestValidation/TrainingRequestValidation";
import FlatTitle from "../LandingPage/components/ContactUs/components/FlatTitle";
import Mouse from "../../components/Mouse/Mouse";
import ScrollTop from "../../components/ScrollTop/ScrollTop";
import CertificationRequestValidation from "./Components/CertificationRequestValidation/CertificationRequestValidation";
import SkillsReports from "./Components/SkillsReports/SkillsReports";

function TrainingManagerSpace() {
  const items = useMemo(
    () => [
      {
        key: "training-plans",
        label: "Training Plans",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <TrainingPlanManager />
          </React.Suspense>
        ),
      },
      {
        key: "budget-overview",
        label: "Budget Overview",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <BudgetOverview />
          </React.Suspense>
        ),
      },
      {
        key: "training-request-validation",
        label: "Training Request Validation",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <TrainingRequestValidation />
          </React.Suspense>
        ),
      },
      {
        key: "certification-request-validation",
        label: "Certification Request Validation",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <CertificationRequestValidation />
          </React.Suspense>
        ),
      },

      {
        key: "skills-reports",
        label: "Skills Reports",
        children: (
          <React.Suspense fallback={<div>Loading...</div>}>
            <SkillsReports />
          </React.Suspense>
        ),
      },
    ],
    []
  );
  const getTab = (tab) => {
    if (
      tab === "training-plans" ||
      tab === "budget-overview" ||
      tab === "training-request-validation" ||
      tab === "certification-request-validation" ||
      tab === "skills-reports" 
    ) {
      return tab;
    }
    return "training-plans";
  };

  const refactorKey = (key) => {
    return key.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  };

  const navigate = useNavigate();
  const { tab } = useParams();
  const [name, setName] = useState(() => getTab(tab));

  const onChangeHeaderName = (key) => {
    navigate(`../trainingmanager/${key}`);
  };

  useEffect(() => {
    setName(refactorKey(getTab(tab)));
  }, [tab]);

  return (
    <>
      <FlatTitle pageName={refactorKey(name)} />
      <div className="section-container">
        <div id="wrapper">
          <Tabs
            tabBarGutter={85}
            activeKey={getTab(tab)}
            items={items}
            onChange={onChangeHeaderName}
            className="custom-tabs"
            destroyInactiveTabPane={true}
          />
          <Mouse />
          <ScrollTop />
        </div>
      </div>
    </>
  );
}

export default TrainingManagerSpace;
